import * as Yup from 'yup';

import { store } from '@stores';
import { translate, zipCodeValidation } from '@utils';

export const getValidationSchema = () => {
  return Yup.string()
    .required(translate('subModules/zipCode:validation.required'))
    .test({
      message: translate('subModules/zipCode:validation.notFound'),
      test: (value) => zipCodeValidation(value, store.utilityStore),
    })
    .length(5, translate('subModules/zipCode:validation.invalid'));
};
